export const UPLOAD_LIMITS = {
    MAX_VIDEO_SIZE_MB: 300,
    MAX_IMAGE_SIZE_MB: 300,
    // SYN-2191: TETO TÉCNICO GLOBAL da plataforma, não o teto do usuário. O limite que vale
    // para o cliente é o do plano (`max_video_duration_seconds` de `/subscriptions/my-usage`,
    // sempre ≤ este valor); quando o plano não impõe limite (legado / sem plano unified) o
    // efetivo cai neste teto. Ver `useMediaUpload.effectiveMaxVideoDurationSec`.
    MAX_VIDEO_DURATION_SEC: 300,
    MIN_VIDEO_DURATION_SEC: 5,
    MIN_RESOLUTION_PX: 240,
    MAX_RESOLUTION_PX: 3840,
    // SYN-1194: caixa simétrica 240-3840 (largura E altura), alinhada ao backend
    // (validate_media) e à Forebrain (SYN-601). Aceita 4K UHD em qualquer
    // orientação, inclusive retrato (2160x3840). Antes a altura travava em 2160
    // (assimétrico), barrando 4K retrato. Hoje espelha MAX_RESOLUTION_PX.
    MAX_VIDEO_HEIGHT_PX: 3840,
    MIN_VIDEO_FPS: 5,
    MAX_VIDEO_FPS: 120,
    ACCEPTED_VIDEO_FORMATS: ['MP4', 'MOV', 'WebM'],
    ACCEPTED_IMAGE_FORMATS: ['JPG', 'PNG', 'WebP'],
};
